export const formatEventLabel = (eventName) =>
  eventName
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
